import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  selector: {
    width: '100%',
  },
}))
